import { Gift, Heart, ExternalLink } from "lucide-react";

export default function RegistrySection() {
  // Replace with your actual registry link
  const registryLink = "https://monzo.me/josephsani?h=pj8IZO";

  return (
    <section className="w-full bg-white py-16 md:py-24 px-6 relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-32 h-32 bg-gradient-to-br from-[#C49355]/10 to-transparent rounded-full -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-40 h-40 bg-gradient-to-tl from-[#E8B46A]/10 to-transparent rounded-full translate-x-1/2 translate-y-1/2" />

      <div className="max-w-3xl mx-auto text-center relative z-10">
        {/* Icon */}
        <div
          className="flex justify-center mb-6"
          data-aos="fade-down"
          data-aos-delay="100"
        >
          <div className="w-20 h-20 rounded-full bg-gradient-to-r from-[#C49355] to-[#E8B46A] flex items-center justify-center shadow-lg">
            <Gift className="w-10 h-10 text-white" />
          </div>
        </div>

        {/* Title */}
        <h2
          className="text-3xl md:text-4xl font-medium mb-4 bg-gradient-to-r from-[#C49355] to-[#E8B46A] bg-clip-text text-transparent"
          //   style={{ fontFamily: "'Times New Roman', Times, serif" }}
          data-aos="fade-up"
          data-aos-delay="200"
        >
          Gift Registry
        </h2>

        {/* Decorative line */}
        <div
          className="flex items-center justify-center gap-4 mb-8"
          data-aos="fade-up"
          data-aos-delay="250"
        >
          <div className="w-16 h-[1px] bg-gradient-to-r from-transparent to-[#C49355]" />
          <Heart className="w-4 h-4 text-[#C49355]" fill="#C49355" />
          <div className="w-16 h-[1px] bg-gradient-to-l from-transparent to-[#E8B46A]" />
        </div>

        {/* Message */}
        <p
          className="text-gray-600 text-base md:text-lg leading-relaxed mb-4"
          style={{ fontFamily: "'Times New Roman', Times, serif" }}
          data-aos="fade-up"
          data-aos-delay="300"
        >
          Your presence at our wedding is the greatest gift of all. However, for
          those who wish to bless us with a gift, we kindly ask for monetary
          contributions towards our future together.
        </p>

        {/* CTA Button */}
        <div data-aos="zoom-in" data-aos-delay="400">
          <a
            href={registryLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-10 py-4 bg-[#3d3d3d] text-white text-base tracking-wide hover:bg-[#2d2d2d] transition-all duration-300 shadow-lg hover:shadow-xl"
            // style={{ fontFamily: "'Times New Roman', Times, serif" }}
          >
            <span>GIFT</span>
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>

        {/* Thank you note */}
        <p
          className="mt-10 text-gray-400 text-sm italic"
          data-aos="fade-up"
          data-aos-delay="500"
        >
          Thank you for being part of our special day
        </p>
      </div>
    </section>
  );
}
